// extracted by mini-css-extract-plugin
export default {"link":"link-button_link__CZj6Q"};